import React from "react"
import { isTomorrow, isToday } from "../../services/Utils"

export class DeliveryDatePickerV2 extends React.Component {
  constructor(props) {
    super(props)

    this.chooseDate = this.chooseDate.bind(this)
  }

  chooseDate(event) {
    this.props.onChange(event)
  }

  renderButtons() {
    return (
      Object.keys(this.props.available_days).map((date) => {
        const on = this.props.available_days[date]
        return (
          <div className='calendar-day' key={date}>
            { on ? this.renderActiveButton(date) : this.renderDisabledButton(date) }
          </div>
        )
      })
    )
  }

  monthName(string_date) {
    const months = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    const index = new Number(string_date.slice(5, 7)) - 1
    return months[index]
  }

  renderDisabledButton(date) {
    const colorClass = isToday(date) ? 'btn-info border-info' : 'border bg-light'
    return (
      <button className={`btn btn-block h-100 px-0 ${ colorClass}`} disabled='disabled'>
        <span className='fa fa-times fa-sm'></span>
      </button>
    )
  }

  renderActiveButton(date) {
    const active = this.props.requested_on == date ? ' active' : ''

    return (
      <button className={`btn btn-block btn-outline-primary px-0${ active }`} value={date} onClick={ this.chooseDate }>
        <div className='small'>
          { this.monthName(date) }
        </div>
        <div>
          { Number(date.slice(8, 10)) }
        </div>
      </button>
    )
  }

  renderDropdown() {
    if (!this.props.expanded) { return }

    return (
      <div className='border rounded bg-light p-2'>
        <div>
          <div className='row no-gutters font-weight-bold'>
            <div className='col text-center'>Su</div>
            <div className='col text-center'>M</div>
            <div className='col text-center'>Tu</div>
            <div className='col text-center'>W</div>
            <div className='col text-center'>Th</div>
            <div className='col text-center'>F</div>
            <div className='col text-center'>Sa</div>
          </div>
          <div className='row no-gutters'>
            { this.renderButtons() }
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div id='delivery-date-picker'>
        { this.renderDropdown() }
      </div>
    )
  }
}
